var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCluster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.972 14.093a3.938 3.938 0 0 0-.977-.136c-.33 0-.645.052-.951.128l-2.37-4.281A3.926 3.926 0 0 0 9.759 7.95h4.471a3.928 3.928 0 0 0 1.095 1.86l-2.353 4.282zM18.038 3c-1.835 0-3.363 1.257-3.808 2.95H9.758A3.942 3.942 0 0 0 5.951 3a3.952 3.952 0 0 0 0 7.903c.337 0 .658-.056.97-.135l2.366 4.274a3.934 3.934 0 0 0-1.244 2.865 3.951 3.951 0 1 0 7.902 0 3.93 3.93 0 0 0-1.223-2.847l2.357-4.288c.31.077.627.13.959.13a3.952 3.952 0 0 0 0-7.902z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/cluster.fa5af928.svg";
export { ForwardRef as ReactComponent };